import React from 'react';

import Modal from 'components/Modal';
import { CORRECT_CONFIRMATION_TEXT } from './constants';

export default function DeactivateAccountComponent(props) {
  const {
    canDeactivate,
    isOpen,
    onChange,
    onDeactivate,
    onRequestClose,
    value,
  } = props;
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
    >
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <h2 className="media__heading heading heading--3">Are you sure?</h2>
        <p>
          This will permanently remove your user account and all characters IN ALL STORYNEXUS WORLDS attached to it.
          {' '}
          <em>
            Please note: deactivation does not cancel mobile Exceptional Friendship.
            {' '}
            To do that, please access your device's Google/Apple account settings.
          </em>
        </p>
        <p>
          To deactivate your account, type
          {' '}
          <b>{CORRECT_CONFIRMATION_TEXT}</b>
          {' '}
here:
        </p>
        <input
          className="form__control form__control--has-buttons"
          onChange={onChange}
          type="text"
          value={value}
        />
        <div className="buttons">
          <button
            className="button button--dangerous"
            disabled={!canDeactivate}
            onClick={onDeactivate}
          >
            Deactivate
          </button>
        </div>
      </div>
    </Modal>
  );
}